import Icon from "../../../icon";
import Button from "../../../button";
import Popup from "../../index";
import React from "react";
import {useDispatch} from "react-redux";
import {userUnShareErrorPopup} from "../../../../../actions/popupActions";
import {Trans, useTranslation} from "react-i18next";
import './index.css';

function FreeLicensesErrorPopup ({response}) {

    const { t } = useTranslation();
    const dispatch = useDispatch();

    return (
        <Popup className="p-4" onClose={() => dispatch(userUnShareErrorPopup(null))}>
            <div className="free-licenses-error-popup">
                <h2 className="text-danger"><Icon name="user-times"/> {t("textErrorOccured")}</h2>
                {
                    response[1] && <p>
                        <Trans i18nKey="userListCannotRemoveLabelNameErrorText" values={{
                            labelName: response[1],
                        }}/>
                    </p>
                }
                <p>
                    <Trans
                        i18nKey="userListRemoveUserFromGoogleAdminConsoleErrorText"
                        components={{a: <a href="https://groups.google.com" target="_blank" rel="noreferrer"> </a>}}
                    />
                </p>
                {
                    response[0].domainGroups && <div className="free-licenses-error-popup__content">
                        <ul>
                            {
                                response[0].domainGroups.map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))
                            }
                        </ul>
                    </div>
                }
                <div className="mt-3 text-right">
                    <Button onClick={() => dispatch(userUnShareErrorPopup(null))}
                            className="btn-primary">{t("okText")}</Button>
                </div>
            </div>
        </Popup>
    )
}

export default FreeLicensesErrorPopup;